import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import { generateToken, slugify } from '../lib/helpers'

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID
}

let db = null
export class FirestoreService {
  constructor() {
    return (async () => {
      if (!db && !firebase.apps.length) {
        firebase.initializeApp(firebaseConfig)
        db = firebase.firestore()
        if (!firebase.auth().currentUser) {
          await firebase.auth().signInAnonymously()
        }
      }
      return this
    })();
  }
  
  createTeam = async (teamName) => {  
    const teamId = generateToken(20)
  
    return db.collection('teams').doc(teamId).set({
      name: teamName,
      creationDate: new Date(),
      updateDate: new Date(),
      votesTotal: 0,
      votesFor1: 0,
      votesFor2: 0,
      votesFor3: 0,
      votes: [],
    })
    .then(() => {
      return {
        voteUrl: `vote/${teamId}/${slugify(teamName)}`,
      }
    })
    .catch((error) => {
      console.error('Error creatign group: ', error)
    })
  }

    
  getTeam = async (id) => {
    return await db.collection('teams').doc(id).get().then((doc) => {
      if (doc.exists) {
        return doc.data()
      } else {
        console.log("No such document!");
      }
    }).catch((error) => {
      console.log("Error getting document:", error);
    });
  }

  addVote = async (teamId, teamName, name, option) => {
    const teamRef = db.collection('teams').doc(teamId);

    const vote = {
      name: name,
      vote: option,
      date: new Date(),
    }

    const updateValues = {
      votes: firebase.firestore.FieldValue.arrayUnion(vote),
      votesTotal: firebase.firestore.FieldValue.increment(1)
    }

    if (option === 1) {
      updateValues['votesFor1'] = firebase.firestore.FieldValue.increment(1)
    } else if (option === 2) {
      updateValues['votesFor2'] = firebase.firestore.FieldValue.increment(1)
    } else if (option === 3) {
      updateValues['votesFor3'] = firebase.firestore.FieldValue.increment(1)
    }

    return teamRef.update(updateValues)
    .then(() => {
      return {
        resultUrl: `result/${teamId}/${slugify(teamName)}`,
      }
    })
    .catch((error) => {
        console.error("Error adding vote: ", error);
    });


  }
}
